import {
  collectCurrentPageRowIds,
  collectLoadedRowIds,
  collectLoadedSelectedRowIds,
  getTraceRowId,
} from "./selectionHelpers";
import { useTracesSelectionStore } from "./traces-selection-context";
import type { TraceGridRow } from "./types";

import { createGridSelectionCells } from "@/components/ui/ag-grid-table";

const { SelectionCheckboxCellRenderer, SelectionHeaderRenderer } = createGridSelectionCells<
  string,
  TraceGridRow
>({
  useSelectionStore: useTracesSelectionStore,
  getRowId: getTraceRowId,
  helpers: {
    collectLoadedRowIds,
    collectCurrentPageRowIds,
    collectLoadedSelectedRowIds,
  },
});

export { SelectionCheckboxCellRenderer, SelectionHeaderRenderer };
